module.exports = __webpack_public_path__ + "static/podwojnie-1-a11d28b89c03c260de4f5c6e820e7651.jpg";